import React from "react";
import {
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectArrayInput,
  SelectInput
} from "react-admin";
import { useFormState, useField } from "react-final-form";

interface ICustomCcaAcademicTermInput {
  parentCallback?: (x: number) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  className?: string;
  multipleSelection?: boolean;
}

const CcaAcademicTermInput = ({
  isRequired,
  isDisabled,
  parentCallback,
  className,
  multipleSelection
}: ICustomCcaAcademicTermInput) => {
  const { values } = useFormState();
  const date = useField("date");

  return multipleSelection ? (
    <ReferenceArrayInput
      className={className}
      label="CCA Academic Term"
      source="ccaAcademicTermIds"
      reference="ccaAcademicTerms"
      filter={{
        CcaAcademicYearId: values.ccaAcademicYearId
          ? parseInt(values.ccaAcademicYearId)
          : 0,
      }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        date && date.input.onChange("");
      }}
      validate={isRequired ? required() : undefined}
      disabled={isDisabled}
    >
      <SelectArrayInput
        optionText="name"
        optionId="id"
        options={{
          MenuProps: {
            PaperProps: {
              style: {
                minWidth: '910px',
                width: 'auto',
              },
            },
          },
        }}
      />
    </ReferenceArrayInput>
  ) : (
    <ReferenceInput
      className={className}
      label="CCA Academic Term"
      source="ccaAcademicTermId"
      reference="ccaAcademicTerms"
      filter={{
        CcaAcademicYearId: values.ccaAcademicYearId
          ? parseInt(values.ccaAcademicYearId)
          : 0,
      }}
      onChange={({ target }) => {
        parentCallback && parentCallback(target.value);
        date && date.input.onChange("");
      }}
      validate={isRequired ? required() : undefined}
      disabled={isDisabled}
    >
      <SelectInput optionText="name" optionId="id" />
    </ReferenceInput>
  );
};

export default CcaAcademicTermInput;
